module.exports = __webpack_public_path__ + "static/JetBrainsMono-Medium-ef1089ea6d73b64008a2feef1f204f6b.woff";